import { render, staticRenderFns } from "./simpleAnalysis.vue?vue&type=template&id=aa486e68&scoped=true"
import script from "./simpleAnalysis.vue?vue&type=script&lang=js"
export * from "./simpleAnalysis.vue?vue&type=script&lang=js"
import style0 from "./simpleAnalysis.vue?vue&type=style&index=0&id=aa486e68&prod&lang=scss&scoped=true"
import style1 from "./simpleAnalysis.vue?vue&type=style&index=1&id=aa486e68&prod&lang=scss"
import style2 from "./simpleAnalysis.vue?vue&type=style&index=2&id=aa486e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa486e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
